import React from 'react'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { PublicRoutes } from '../config/routes.config'
import ActionButton from '../components/Button/Button'

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate(PublicRoutes.LOGIN)
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
      <Typography variant="h1" color="primary" gutterBottom>
        403
      </Typography>
      <Typography variant="h5" color="textSecondary" gutterBottom>
        You are not authorized to access this page
      </Typography>
      <ActionButton size="medium" onClick={handleGoHome}>
        Go to Login Page
      </ActionButton>
    </Box>
  )
}

export default UnauthorizedPage
